import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Fire-and-forget event logger. Never blocks UI or throws. */
export function logEvent(eventType, metadata = {}) {
  axios
    .post(`${API}/user-events`, { event_type: eventType, metadata }, { withCredentials: true })
    .catch(() => {});
}
